import { render } from "./ToBeConfirmed.vue?vue&type=template&id=1db03c36&scoped=true"
import script from "./ToBeConfirmed.vue?vue&type=script&lang=js"
export * from "./ToBeConfirmed.vue?vue&type=script&lang=js"

import "./ToBeConfirmed.vue?vue&type=style&index=0&id=1db03c36&scoped=true&lang=less"

import exportComponent from "/home/huiwen/TeamCity/buildAgent/work/78c9eac71a3ca1e9/webs/pdam-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db03c36"]])

export default __exports__